import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionsDashboardComponent } from './transport-interventions-dashboard.component';
import {DxScrollViewModule, DxToolbarModule} from 'devextreme-angular';
import {TransportInterventionsRealtimeListModule} from '../transport-interventions-realtime-list/transport-interventions-realtime-list.module';
import {DashboardWidgetModule} from '../../dashboard/dashboard-widget/dashboard-widget.module';
import {ExamplePieWidgetModule} from '../../dashboard/widgets/example-pie-widget/example-pie-widget.module';
import {ExampleBarWidgetModule} from '../../dashboard/widgets/example-bar-widget/example-bar-widget.module';
import {ExampleGridWidgetModule} from '../../dashboard/widgets/example-grid-widget/example-grid-widget.module';
import {ExampleNumberWidgetModule} from '../../dashboard/widgets/example-number-widget/example-number-widget.module';
import {TractorsPerDomainWidgetModule} from '../../dashboard/widgets/tractors-per-domain-widget/tractors-per-domain-widget.module';
import {DashboardSectionModule} from '../../dashboard/dashboard-section/dashboard-section.module';
import {TransportInterventionTimeWidgetModule} from './widgets/transport-intervention-time-widget/transport-intervention-time-widget.module';



@NgModule({
  declarations: [TransportInterventionsDashboardComponent],
  imports: [
    CommonModule,
    DxScrollViewModule,
    TransportInterventionsRealtimeListModule,
    DashboardWidgetModule,
    ExamplePieWidgetModule,
    ExampleBarWidgetModule,
    ExampleGridWidgetModule,
    ExampleNumberWidgetModule,
    TractorsPerDomainWidgetModule,
    DxToolbarModule,
    DashboardSectionModule,
    TransportInterventionTimeWidgetModule
  ],
  exports: [TransportInterventionsDashboardComponent]
})
export class TransportInterventionsDashboardModule { }
